import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import 'uno.css'
import App from './App.vue'
import { createPinia } from 'pinia'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './styles/main.scss'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import plugins from '@/utils/plugins/index.ts'

async function bootstrap() {
    const app = createApp(App)

    const pinia = createPinia()
    app.use(pinia)

    app.use(ElementPlus, {
        locale: zhCn,
    })

    app.use(router)

    // 如果 plugins 有 async install 方法，就在这里 await
    if (typeof plugins.install === 'function') {
        await plugins.install(app)
    }

    app.mount('#app')
}

bootstrap()
